import { ReviewStepContainer } from '../../../../steps/ReviewStep/ReviewStepContainer.js';

const reviewStepBase = {
    view: ReviewStepContainer
};

export { reviewStepBase };
//# sourceMappingURL=review.js.map
